"use client";

import React from "react";
import LinkItem from "./LinkItem";
import { useGlobalStore } from "@/app/context/globalStoreProvider";

type Props = {
  logoSrcLinkPath: string;
};

const LeftContainer: React.FC<Props> = ({ logoSrcLinkPath }) => {
  const { isEventPage } = useGlobalStore();

  return (
    <div className="flex items-center">
      {isEventPage ? (
        <>
          {/* Logo icon for < lg */}
          <img
            src="/assets/logos/gondola.svg"
            alt="gondola-logo"
            className="block h-[40px] w-[40px] lg:hidden"
          />
          {/* Logo text for >= lg */}
          <img
            src="/assets/logos/gondola-logo-text.svg"
            alt="gondola-logo"
            className="hidden h-[33px] w-full md:h-[40px] lg:block"
          />
        </>
      ) : (
        <LinkItem path={logoSrcLinkPath} className="w-full">
          {/* Logo icon for < lg */}
          <img
            src="/assets/logos/gondola.svg"
            alt="gondola-logo"
            className="block h-[40px] w-[40px] lg:hidden"
          />
          {/* Logo text for >= lg */}
          <img
            src="/assets/logos/gondola-logo-text.svg"
            alt="gondola-logo"
            className="hidden h-[33px] w-full md:h-[40px] lg:block"
          />
        </LinkItem>
      )}
    </div>
  );
};

export default LeftContainer;
